import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as kiwiSdk from '@huyafed/huya-kiwi'
import './theme/wiki-token-bridge.css'
import './index.css'
import '@/global'
import Constants from '@/constants'
import { getToolId } from '@/config/env'
import { tafFetch } from '@/api/_tafFetch'
import logger from '@/utils/logger'
import App from './App'

const logRuntimeInitializationError = (error: unknown) => {
  const message = '[GameToolRuntime] initialization failed'
  try {
    logger.error(message, { error })
  } catch (loggerError) {
    console.warn('[GameToolRuntime] SDK logger failed:', loggerError)
  }
  console.warn(`${message}:`, error)
}

const initializeRuntime = () => {
  try {
    void window.GameToolRuntime
      ?.init({
        gameId: Constants.GAME_ID,
        toolId: getToolId(),
        env: Constants.IS_TAF_TEST ? 'test' : 'prod',
        tafFetch,
        sdk: kiwiSdk,
      })
      .catch(logRuntimeInitializationError)
  } catch (error) {
    logRuntimeInitializationError(error)
  }
}

initializeRuntime()
window.addEventListener('hashchange', initializeRuntime)

console.log('[game-wiki] BASE_URL:', import.meta.env.BASE_URL)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
